<template>
    
    <div>
        
        <div v-if="!companies || companies.length == 0">

            <v-alert type="info">
                {{ $t('No companies found') }}
            </v-alert>

            <v-btn @click="signOut()">
                {{ $t('Logout') }}
            </v-btn>

        </div>

        <div class="text-center pa-6" v-if="companies_loader">
            
            <v-progress-circular
            indeterminate
            color="blue"
            ></v-progress-circular>
            
        </div>

        <v-card outlined tile v-for="company in companies" :key="company.id" @click="setCompanyMethod(company)">

            <div class="d-flex pa-2 align-center">

                <v-icon class="mr-2">mdi-domain</v-icon>

                {{company.name}}

                <v-spacer></v-spacer>

                <v-btn icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                
            </div>
            
        </v-card>

        <div v-if="error">
            
            <v-alert type="error">
                {{error}}
            </v-alert>

            <div>

                <v-btn @click="signOut()">
                    {{ $t('Logout') }}
                </v-btn>

            </div>

        </div>

    </div>

</template>

<script>

import { mapGetters, mapActions } from "vuex";
import companiesApi from "@/api/companies/Companies" ;
import helpers from "@/helpers";

export default {

    name: "Reporters",
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            currentCompany: "companies/currentCompany",
            companies: "companies/companies",
        })
    },
    data () {
        return {
            companies_loader: true,
            error: null
        }
    },
    created() {

        let _this = this ; 

        if(this.companies === null){

            let api = new companiesApi() ;

            api.get().then(function(data) {

                // success
                if(data === 'string'){
                    _this.error = _this.$t('No companies found') ; 
                }

                if(data.length == 0){
                    _this.error = _this.$t('No companies found') ; 
                }

                _this.companies_loader = false ;

            })
            .catch(errorMessage => {

                if(errorMessage.response){
                    _this.error = errorMessage.response.data.error.message+" ("+errorMessage.response.data.error.code+")" ; 
                }else{
                    _this.error = errorMessage ; 
                }

                _this.companies_loader = false ;
                
            });

        }else{
            _this.companies_loader = false ;
        }
        
    },
    methods: {

        ...mapActions({
            setCompany: 'companies/setCompany'
        }),
        
        signOut() {
            helpers.signOut();            
        },
        
        setCompanyMethod(company){

            // set currentCompany
            this.setCompany(company) ; 

        },

        getDevices(reporter_id){

            return this.devices.filter(function( obj ) {
                return obj.reporter_id === reporter_id ;
            });

        }
    }

};

</script>